module.exports = __webpack_public_path__ + "static/media/contactBGen.cadbc13a.png";